import { AtlasBadgeOwnProps, Badge, Tooltip } from "@resource/atlas";
import clsx from "clsx";

type DefaultTemplateBadgeProps = AtlasBadgeOwnProps & {
  className?: string;
  guideTemplate: {
    isGlobal: boolean;
    department: {
      name: string;
    } | null;
  };
};

export function DefaultTemplateBadge({
  guideTemplate,
  className,
  ...props
}: DefaultTemplateBadgeProps) {
  return guideTemplate.isGlobal ? (
    <Tooltip
      content={
        guideTemplate.department
          ? `Default guide template for the ${guideTemplate.department.name} department`
          : "Default template for the organization"
      }
    >
      {guideTemplate.department ? (
        <Badge {...props} className={clsx(className)} variant="default">
          {guideTemplate.department.name}
        </Badge>
      ) : (
        <Badge
          {...props}
          className={clsx("!text-purple-500 !bg-purple-50", className)}
        >
          Default
        </Badge>
      )}
    </Tooltip>
  ) : null;
}
